<app-dialog
	modalTitle="Benefícios do Dependente"
	titleButton="Fechar"
	secTitleButton="Cancelar"
	[secButton]="true"
	[hideFooter]="false"
	[noMargins]="true"
	(dialogClose)="closeModal()"
	(dialogSave)="closeModal()"
>
	<ng-container *ngIf="loading">
		<div class="d-f jc-c ai-c w-100 mt-giant">
			<mat-spinner diameter="20"></mat-spinner>
		</div>
	</ng-container>
	<ng-container
		*ngIf="!loading && benefitsLoaded && healthBenefits && dentalBenefits"
	>
		<div class="w-100 h-100 container" [formGroup]="form">
			<ng-container *ngIf="showConjugated">
				<div class="d-f mt-xxxs ml-xxxs line">
					<mat-form-field
						class="mr-xxxs col-1"
						title="Plano de saúde e dental (Conjugado)"
						appearance="outline"
					>
						<mat-label>Plano de saúde e dental</mat-label>
						<mat-select formControlName="conjugated_plan">
							<mat-option
								*ngFor="let ben of conjugatedBenefits"
								[value]="ben?.id"
							>
								{{ ben?.name }}
							</mat-option>
						</mat-select>
						<mat-error
							*ngIf="
								form.get('conjugated_plan')?.hasError('required') &&
								!form.get('conjugated_plan')?.disabled
							"
						>
							Campo obrigatório
						</mat-error>
					</mat-form-field>
					<mat-form-field
						class="mr-xxxs col-1"
						title="Carteirinha conjugada"
						appearance="outline"
					>
						<mat-label>Carteirinha conjugada</mat-label>
						<input
							type="text"
							matInput
							placeholder="Carteirinha conjugada"
							formControlName="conjugated_card"
							id="skconj-{{ inputId }}"
						/>
						<mat-error
							*ngIf="
								form.get('conjugated_card')?.hasError('required') &&
								!form.get('conjugated_card')?.disabled
							"
						>
							Campo obrigatório
						</mat-error>
					</mat-form-field>
				</div>
			</ng-container>

			<ng-container *ngIf="!showConjugated">
				<div class="d-f mt-xxxs ml-xxxs line">
					<mat-form-field
						class="mr-xxxs col-1"
						title="Plano de saúde"
						appearance="outline"
					>
						<mat-label>Plano de saúde</mat-label>
						<mat-select formControlName="health_plan">
							<mat-option *ngFor="let ben of healthBenefits" [value]="ben?.id">
								{{ ben?.name }}
							</mat-option>
						</mat-select>
						<mat-error
							*ngIf="
								form.get('health_plan')?.hasError('required') &&
								!form.get('health_plan')?.disabled
							"
						>
							Campo obrigatório
						</mat-error>
					</mat-form-field>
					<mat-form-field
						class="mr-xxxs col-1"
						title="Carteirinha de saúde"
						appearance="outline"
					>
						<mat-label>Carteirinha de saúde</mat-label>
						<input
							type="text"
							matInput
							placeholder="Carteirinha de saúde"
							formControlName="health_card"
							id="skh-{{ inputId }}"
						/>
						<mat-error
							*ngIf="
								form.get('health_card')?.hasError('required') &&
								!form.get('health_card')?.disabled
							"
						>
							Campo obrigatório
						</mat-error>
					</mat-form-field>
				</div>
				<div class="d-f mt-xxxs ml-xxxs line">
					<mat-form-field
						class="mr-xxxs col-1"
						title="Plano dental"
						appearance="outline"
					>
						<mat-label>Plano dental</mat-label>
						<mat-select formControlName="dental_plan">
							<mat-option *ngFor="let ben of dentalBenefits" [value]="ben?.id">
								{{ ben?.name }}
							</mat-option>
						</mat-select>
						<mat-error
							*ngIf="
								form.get('dental_plan')?.hasError('required') &&
								!form.get('dental_plan')?.disabled
							"
						>
							Campo obrigatório
						</mat-error>
					</mat-form-field>
					<mat-form-field
						class="mr-xxxs col-1"
						title="Carteirinha dental"
						appearance="outline"
					>
						<mat-label>Carteirinha dental</mat-label>
						<input
							type="text"
							matInput
							placeholder="Carteirinha dental"
							formControlName="dental_card"
							id="skd-{{ inputId }}"
						/>
						<mat-error
							*ngIf="
								form.get('dental_card')?.hasError('required') &&
								!form.get('dental_card')?.disabled
							"
						>
							Campo obrigatório
						</mat-error>
					</mat-form-field>
				</div>
			</ng-container>
		</div>
	</ng-container>
</app-dialog>
